export default function Loader(){

    return(

        <div className="crm-loader">

            Loading...

        </div>

    );

}